import { Box } from '@material-ui/core'
import React from 'react'
import CardTeam from '../common/CardTeam'
import PricingPlan from './PricingPlan'
const CardPreferredStatus = ({ locationStatus }) => (
  <CardTeam>
    <Box display={'flex'} alignItems="center" justifyContent={'center'} flexDirection="column">
      <PricingPlan locationStatus={locationStatus} />
    </Box>
  </CardTeam>
)
export default CardPreferredStatus
